//WEEK 4.1
export const ADD_COMMENT = 'ADD_COMMENT';